var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-dialog",
    {
      attrs: {
        visible: _vm.visible,
        "show-close": false,
        width: "480px",
        top: "8vh",
        "empty-header": "",
      },
      on: { close: _vm.closeDialog },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("ib-divider", { staticClass: "mb-4", attrs: { block: "" } }),
              _c("ib-dialog-footer", {
                attrs: {
                  "button-size": "sm",
                  "submit-btn-text": _vm.$t("cancelSubscriptionButton"),
                  "cancel-btn-text": _vm.$t("dialogs.remove.noJustKidding"),
                  "variant-button": "red",
                  "outline-button": "",
                  loading: _vm.loading,
                },
                on: { cancel: _vm.closeDialog, submit: _vm.cancelAccount },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("ib-dialog-confirmation-content", {
        attrs: {
          image: require("@/assets/img/illustrations/cancel-subscription.svg"),
          title: _vm.$t("cancelSubscriptionTitle"),
          subtitle: _vm.message,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }